import {Component, OnInit, OnDestroy,  ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BrowserModule, Title } from '@angular/platform-browser';
import { ApiService } from '../../services/api.service';
import { ConfigurationService } from '../../services/configuration.service';
import { ActivatedRoute } from '@angular/router';
import { Http, Response } from '@angular/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QuestionsService } from './../../services/questions.service';
import { TranslatesService } from './../../services/translates.service';

@Component({
  selector: 'stg-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit, OnDestroy {

  public score = 0;
  private tripId = 1;
  private subscriptions: any;
  public username = '';
  public error = false;
  private titleIndex = 'result-page-title';
  showShare = false;
  // vars used only for example, put anything you want :)
  public repoUrl = 'https://graterenowa.nysa.eu/#/ranking';
  public imageUrl = 'https://brandingmonitor.pl/wp-content/uploads/2016/06/nowe-logo-nysy-logotyp-696x300.png';

  constructor(
    private questionsService: QuestionsService,
    private route: ActivatedRoute,
    public translate: TranslatesService,
    private router: Router,
    private apiService: ApiService,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle(this.translate.getText(this.titleIndex));
    this.subscriptions = this.route.params.subscribe(params => {
      this.tripId = +params['id']; // (+) converts string 'id' to a number
      this.score = this.questionsService.countScore(this.tripId);
      this.questionsService.clearScores(this.tripId);
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public sendScore() {
    const regex = /^[\w]{3,}$/gi;
    if (regex.test(this.username) === false) {
      this.error = true;
      return;
    } else {
      this.error = false;
    }
    this.apiService.saveScore(1, this.username, this.score, this.tripId).subscribe(
      (res: any) => {
        if (res.status === 'success') {
          this.router.navigateByUrl('/ranking');
        }
      },
      err => console.log(err), // error
      () => { }
    );
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/views/result/result.component.ts